import Box from '@mui/material/Box'
import OcrReaderLogo from 'assets/images/logoSl.svg'
import BarMenuButton from 'components/Mobile/BarMenuButton'

const LogoBar = () => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          height: '3rem',
          backgroundColor: 'primary.light',
          justifyContent: 'center',
          alignItem: 'center',
          py: 2,
        }}
      >
        <h1 style={{ fontSize: 0 }}>LINE WORKS OCR</h1>
        <img src={OcrReaderLogo} alt="logo" style={{ objectFit: 'contain', maxWidth: '100%' }} />
      </Box>
      <BarMenuButton />
    </>
  )
}

export default LogoBar
